import { ShieldX } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function Forbidden() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <div className="flex size-12 items-center justify-center rounded-full bg-destructive/10 text-destructive">
        <ShieldX className="size-6" />
      </div>
      <h2 className="text-lg font-semibold">Acceso restringido</h2>
      <p className="max-w-sm text-sm text-muted-foreground">Tu rol no tiene permisos para este módulo. Solicita acceso al administrador.</p>
      <Link to="/"><Button variant="outline" size="sm">Volver al inicio</Button></Link>
    </div>
  );
}

export function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <p className="font-mono text-5xl font-semibold text-muted-foreground/40">404</p>
      <h2 className="text-lg font-semibold">Página no encontrada</h2>
      <p className="text-sm text-muted-foreground">La ruta que buscas no existe o ha cambiado.</p>
      <Link to="/"><Button size="sm">Ir al cuadro de mando</Button></Link>
    </div>
  );
}
